import { noop } from 'lodash/fp';
import { OptimusPlainLink } from '@mews-commander/ui';
import { Target } from '@mews/enums';
import { ListItem, ListItemProps } from '@optimus-web/core';

interface LinkedListItem extends ListItemProps {
    value: string;
    target?: Target;
}

const LinkedListItem: React.FC<LinkedListItem> = ({ value, target, ...other }) => (
    <OptimusPlainLink href={value} onClick={noop} target={target} underline={false} inherit>
        <ListItem {...other} value={value} />
    </OptimusPlainLink>
);

export default LinkedListItem;
